/*
 * @Description: 用户相关接口
 */
import { RootObject } from '@/model/rootObject'
import {
  UserInfoModel,
  Users,
  UserPageModel,
  UserPageParamModel,
  UserCreateModel,
  UserUpdateModel,
  UserUpdatePasswordModel,
  UpdatePasswordModel, UserLogInFirstStepModel, UserViewModel
} from '@/model/userModel'
import https, { httpWithToken, retrieveImageUrl } from '@/utils/https'
import { RequestParams, ContentType, Method } from 'axios-mapper'
import { responseFilter } from './response_filter'
import networkConfig from '@/config/default/net.config'

export const loginRequest = (userInfo: RequestParams) => {
  return responseFilter(https(false).request<RootObject<string>>('/login/auth', Method.POST, userInfo, ContentType.json))
}

export const loginVerify = (userInfo: RequestParams) => {
  return https(false).request<RootObject<UserLogInFirstStepModel>>('/login/verify', Method.POST, userInfo, ContentType.json)
}

export const generateMfaQrCode = (token: string, param?: RequestParams) => {
  const baseURL = networkConfig.host
  return retrieveImageUrl(baseURL + '/generate-mfa-qrCode', token, param)
}

export const bindMFA = (token: string, mfaInfo: RequestParams) => {
  return httpWithToken(token).request<RootObject<string>>('/mfa/bind', Method.POST, mfaInfo, ContentType.json)
}

export const rebindMFA = (token: string, mfaInfo: RequestParams) => {
  return httpWithToken(token).request<RootObject<string>>('/mfa/rebind', Method.POST, mfaInfo, ContentType.json)
}

export const verifyMFA = (token: string, mfaInfo: RequestParams) => {
  return httpWithToken(token).request<RootObject<string>>('/mfa/verify', Method.POST, mfaInfo, ContentType.json)
}

export const userInfoRequest = () => {
  return responseFilter(https().request<RootObject<UserInfoModel>>('/login/getInfo', Method.GET, undefined, ContentType.form))
}

export const getUsers = (user: any) => {
  return https().request<RootObject<Users>>('getUser', Method.GET, user, ContentType.form)
}

export const getUserListForPage = (params: UserPageParamModel) => {
  return https().request<RootObject<UserPageModel>>('/base/user/list', Method.POST, params, ContentType.json)
}

export const getUserInfoById = (userId: number) => {
  return https().request<RootObject<UserViewModel>>('/base/user/get/' + userId, Method.GET, undefined, ContentType.json)
}

export const createUser = (params: UserCreateModel) => {
  return https().request<RootObject<number>>('/base/user/add', Method.POST, params, ContentType.json)
}

export const updateUser = (params: UserUpdateModel) => {
  return https().request<RootObject<number>>('/base/user/edit', Method.POST, params, ContentType.json)
}

export const deleteUser = (userId: number) => {
  return https().request<RootObject<number>>('/base/user/delete/' + userId, Method.POST, undefined, ContentType.json)
}

export const updatePassword = (params: UpdatePasswordModel) => {
  return https().request<RootObject<number>>('/base/user/edit/password', Method.POST, params, ContentType.json)
}

export const updateUserPassword = (userId: number | null, params: UserUpdatePasswordModel) => {
  return https().request<RootObject<number>>('/base/user/edit/password/' + userId, Method.POST, params, ContentType.json)
}

export const verifyUser = (params: RequestParams) => {
  return https().request<RootObject<boolean>>('/base/user/verify', Method.POST, params, ContentType.json)
}

export const initializePassword = (userId: number) => {
  return https().request<RootObject<number>>('/base/user/initialize/password/' + userId, Method.POST, undefined, ContentType.json)
}
